import { pushGaData } from '../common';
const headerLogo = (rootStore) => {
    const { app, URLData } = rootStore.environmentStore;
    const { setLocation, segment } = rootStore.locationStore;
    const { setSection } = rootStore.sectionStore;
    const pushLogoGa = () => {
        pushGaData({
            eventAction: 'Logo Click',
            eventLabel: 'Click'
        });
    };
    const setLocationAndPushGa = (event) => {
        pushLogoGa();
        setSection(null);
        setLocation(event);
    };
    const getLogoUrl = () => {
        const baseUrl = app === 'public' ? URLData.localizedPath : URLData.publicURL;
        if (segment === 'ari') {
            return `${baseUrl}/ari`;
        }
        else {
            return `${baseUrl}/era`;
        }
    };
    return {
        className: 'nls_protected',
        url: getLogoUrl(),
        text: 'Telia',
        onClick: setLocationAndPushGa
    };
};
export default headerLogo;
//# sourceMappingURL=HeaderLogo.js.map